<img *ngIf="image" [src]="image.lastUrl" [alt]="alt" />
